// Module
var code = `<div>
  <div class="grid">
    <div class="grid-header grid-row">
      <div>Id</div>
      <div>Branch</div>
      <div>System Date</div>
      <div>Registration Time</div>
      <div>Task Type</div>
      <div>Error Code</div>
      <div>Stacktrace</div>
      <div>Resolve</div>
    </div>

    <div ng-repeat="processingIssue in \$ctrl.processingIssues" class="grid-row">
      <div>{{processingIssue.id}}</div>
      <div>{{processingIssue.branch.name}}</div>
      <div>{{processingIssue.systemDate | prettyDate }}</div>
      <div>{{processingIssue.registrationTime}}</div>
      <div>{{processingIssue.taskType}}</div>
      <div>{{processingIssue.errorCode}}</div>
      <div title={{processingIssue.stackTrace}}>{{processingIssue.shortenedStackTrace}}</div>
      <div>
        <button
          type="button"
          class="btn btn-success"
          ng-click="\$ctrl.resolveIssue(processingIssue)">
          Resolve issue
        </button>
      </div>
    </div>
  </div>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/resolve-processing-issues/resolve-processing-issues.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;